<div class="ui-date-input">
  @if (showLabel()) {
    <div class="ui-date-input__header">
      <label class="ui-date-input__label" [attr.for]="inputId()">{{ label() }}</label>
      @if (showRequirement()) {
        <span
          class="ui-date-input__requirement"
          [class.ui-date-input__requirement--error]="invalid() && required()"
          aria-hidden="true"
        >
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  <div
    class="ui-date-input__field"
    [class.ui-date-input__field--invalid]="invalid()"
    [class.ui-date-input__field--disabled]="disabled()"
  >
    <input
      #inputEl
      class="ui-date-input__control"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.placeholder]="placeholder() || (kind() === 'time' ? 'hh:mm' : kind() === 'datetime' ? 'dd/mm/aaaa hh:mm' : 'dd/mm/aaaa')"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      (input)="onDateMask($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />
    <span class="ui-date-input__icon" aria-hidden="true">
      @if (kind() === 'time') {
        <!-- Reloj -->
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>
          <path d="M8 5v3.5l2.5 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      } @else {
        <!-- Calendario -->
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="3" width="14" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
          <path d="M1 7h14" stroke="currentColor" stroke-width="1.5"/>
          <path d="M5 1v4M11 1v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
    </span>
  </div>

  @if (message()) {
    <p
      class="ui-date-input__message"
      [id]="messageId()"
      [class.ui-date-input__message--error]="invalid()"
      [attr.role]="invalid() ? 'alert' : null"
    >
      {{ message() }}
    </p>
  }
</div>
